import React, { useEffect } from 'react';

export default function TickerUndoToast({ message, onUndo, onDismiss, durationMs = 5000 }) {
    useEffect(() => {
        const timer = setTimeout(onDismiss, durationMs);
        return () => clearTimeout(timer);
    }, [onDismiss, durationMs]);

    return (
        <div className="ticker-undo-toast" role="status">
            <span>{message}</span>
            <button type="button" className="ticker-undo-btn" onClick={onUndo}>
                Rückgängig
            </button>
            <button type="button" className="ticker-undo-close" onClick={onDismiss} aria-label="Schließen">✕</button>
        </div>
    );
}
